import { render, staticRenderFns } from "./FileAttachments.vue?vue&type=template&id=f2548988&scoped=true&"
import script from "./FileAttachments.vue?vue&type=script&lang=js&"
export * from "./FileAttachments.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachments.vue?vue&type=style&index=0&id=f2548988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2548988",
  null
  
)

export default component.exports